import { render } from "./Success.vue?vue&type=template&id=04df4dec&scoped=true&ts=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"

import "./Success.vue?vue&type=style&index=0&id=04df4dec&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04df4dec"]])

export default __exports__